import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme/contract.css';

/**
 * 회차 성과 펼침 (퀘스트 e91872f1 CP3) — 발송 이력 표의 회차 줄 바로 아래에 선다.
 *
 * 상자·배경을 두르지 않는다 — 표 안의 한 줄이라 위 회차 줄과 같은 면으로 읽혀야 한다. 단계 칸은 창 폭을
 * 따라 접힌다(미디어쿼리는 앱 안 창 폭을 못 읽어 쓰지 않는다).
 */
export const panel = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.md,
});

export const head = style({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: vars.spacing.gap.sm,
});

export const heading = style({
  margin: 0,
  fontSize: vars.typography.fontSize.sm,
  fontWeight: String(vars.typography.fontWeight.bold),
  color: vars.typography.textColor.primary,
});

/** 상태는 중립색으로 말한다(DESIGN.md 상태 신호) — 집계 중·최종·발송 안 됨 어느 것도 경고가 아니다. */
export const badge = style({
  display: 'inline-block',
  padding: `${vars.spacing.padding['2xs']} ${vars.spacing.padding.sm}`,
  borderRadius: vars.spacing.borderRadius.full,
  fontSize: vars.typography.fontSize['3xs'],
  whiteSpace: 'nowrap',
  background: vars.surface.card.hover,
  border: `1px solid ${vars.surface.border.subtle}`,
  color: vars.typography.textColor.secondary,
});

export const funnel = style({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
  gap: vars.spacing.gap.md,
  margin: 0,
});

export const stat = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
  minWidth: 0,
});

export const label = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.label,
});

export const value = style({
  display: 'flex',
  alignItems: 'baseline',
  flexWrap: 'wrap',
  gap: vars.spacing.gap.xs,
  margin: 0,
});

export const count = style({
  fontSize: vars.typography.fontSize.lg,
  fontWeight: String(vars.typography.fontWeight.bold),
  color: vars.typography.textColor.primary,
  fontVariantNumeric: 'tabular-nums',
});

export const rate = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
  fontVariantNumeric: 'tabular-nums',
});

export const basis = style({
  margin: 0,
  fontSize: vars.typography.fontSize['2xs'],
  color: vars.typography.textColor.softMuted,
});

export const notes = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
  margin: 0,
  paddingLeft: 0,
  listStyle: 'none',
  fontSize: vars.typography.fontSize['2xs'],
  lineHeight: String(vars.typography.lineHeight.relaxed),
  color: vars.typography.textColor.tertiary,
});

export const note = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
});
